import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { ListService } from '../services';
import { BaseComponent } from '../shared';
import { FiltersComponent } from './filters';
import { ListTableComponent } from './list-table';


/**
 * Component for List of Patients page.
 */
@Component({
	selector: 'tsp-list',
	imports: [
		FiltersComponent,
		NgbCollapseModule,
		ListTableComponent
	],
	templateUrl: './list.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class ListComponent extends BaseComponent implements OnInit, OnDestroy {

	private readonly listSrv = inject(ListService);

	isFiltersCollapsed = signal(true);


	ngOnInit(): void {
		this.listSrv.search();
	}


	ngOnDestroy(): void {
		this.listSrv.reset();
	}

}
